
import BaseAlert from "@/components/base/BaseAlert.vue";
import BaseSpinner from "@/components/base/BaseSpinner.vue";
import LeadPassenger from "@/components/bookingflow/steps/passengerdetails/LeadPassenger.vue";
import PassengerList from "@/components/bookingflow/steps/passengerdetails/PassengerList.vue";
import AgentCustomer from "@/components/bookingflow/steps/passengerdetails/AgentCustomer.vue";
import usePassengers from "@/composables/usePassengers";
import { UserType } from "@/models/enums";
import { useUserStore } from "@/store/user";
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
	components: {
		PassengerList,
		LeadPassenger,
		AgentCustomer,
		BaseAlert,
		BaseSpinner
	},
	setup() {
		const { syncPassengers } = usePassengers();
		const loading = ref<boolean>(true);
		const error = ref("");
		const userStore = useUserStore();
		
		onMounted(() => {
			syncPassengers()
			.catch(err => error.value = err)
			.finally(() => loading.value = false);
		})
		
		const isAgent = userStore.getUserType == UserType.Agent;
		
		return { loading, error, isAgent }
	}
});
